// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AddAdvanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_AddAdvanceResponseDados {
id: number
recebimento_id: number
user_id: string
amount: number
}

export type Payroll_AddAdvanceResponse = ApiResponse<Payroll_AddAdvanceResponseDados>;

registerResponseContract('Payroll_AddAdvanceResponse', {
  id:             { type: 'number',  required: true },
  recebimento_id: { type: 'number',  required: true },
  user_id:        { type: 'string',  required: true },
  amount:         { type: 'number',  required: true },
})
